import PropTypes from 'prop-types';
import React from 'react';
import PureComponent from '../pure';
import {ScrollSync, ScrollSyncPane} from 'react-scroll-sync';

import ListViewFooter from './ListViewFooter';

import NewListViewHeaderField from './NewListViewHeaderField';
import NewListViewField from './NewListViewField';
import ListViewFilterContainer from './listViewFilterContainer';
import MoreOptions from '../formElements/MoreOptions';
import ListViewTableTree from './listViewTableTree';
import ListViewTableDropZone from './listViewTableDropZone';
import TickBox from '../formElements/TickBox';
import Report from '../CustomReport/Report';
import sAction from 'sAction';

class ListViewTable extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            drag: false,
            lockColumns: this.props.data.lockedColumnsCount && this.props.data.lockedColumnsCount > 0,
            lockedColumns: this.props.data.lockedColumnsCount,
        };
        this.table = React.createRef();
        this.lockedTable = React.createRef();
        this.header = React.createRef();
        this.lockedHeader = React.createRef();
        this.scrollTable = React.createRef();
        this.lastHoverLine = null;
        this.scrollLeft = 0;
        this.maxSizeSubpanel = false;
    }

    componentDidMount() {
        const table = this.table.current;
        const prefix = this.props.prefix;
        sAction.afterLoadListView(prefix, table, this.props.data.type);

        this.listener = (evt) => {
            sAction.afterLoadListView(prefix, table, this.props.data.type);
        };
        window.addEventListener('resize', this.listener);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.listener);
    }

    componentDidUpdate(prevProps) {
        const prefix = this.props.prefix;
        const table = this.table.current;
        if (this.props.data.modul != prevProps.data.modul) {
            sAction.afterLoadListView(prefix, table, this.props.data.type);
        }
        this.setState({
            lockColumns: this.props.data.lockedColumns,
            lockedColumns: this.props.data.lockedColumnsCount,
        });
    }

    dragActive() {
        const data = this.props.data;
        if (data.modul == 'Documents') {
            const way = this.props.prefix;
            sAction.dataSet(way + '/dropZoneActive', true);
        }
    }

    scroll(e) {
        const data = this.props.data;

        if (e.target.scrollLeft !== this.scrollLeft && data.openFilterData != null) {
            if (data.openFilterData.open === true) {
                const prefix = this.props.prefix;
                sAction.dataSet(prefix + '/openFilterData/open', false);
            }
        }
    }

    subpanelLineMoreAction(e, val, rec) {
        if (this.props.parent != undefined) {
            try {
                const obj = {
                    action: val,
                    record: rec,
                };
                this.props.parent.subpanelLineMoreAction(e, obj);
            } catch (error) {
                console.log(error);
            }
        }
    }

    mouseOver(e) {
        const elems = document.querySelectorAll('.newListViewLine.hover');
        elems.forEach((el) => {
            el.classList.remove('hover');
        });

        let target = e.target;
        if (!target.classList.contains('newListViewLine')) {
            target = target.closest('.newListViewLine');
        }
        if (target !== null) {
            const index = Array.from(target.parentNode.children).indexOf(target) + 1;
            const cels = this.table.current.querySelectorAll(
                '.newListViewRow .newListViewLine:nth-child(' + index + ')',
            );
            cels.forEach((cel) => {
                cel.classList.add('hover');
            });
        }
    }

    removeHover() {
        const elems = document.querySelectorAll('.newListViewLine.hover');
        elems.forEach((el) => {
            el.classList.remove('hover');
        });
    }

    /**
   *
   * @param index   index of record
   * @return {null|string} null if not found or record ID
   */
    getIdByIndex = (index) => {
        return this.props.data.records.get(index) ?? null;
    };

    /**
   *
   * @param index     index of NewListViewField
   * @param property  name of property, eg. NAME or EMAIL1
   * @return {null|string} null if not found or property value
   */
    getPropertyValueByIndex = (index, property) => {
        const row = this.props.data.rows.filter(
            (row) => row.get('key').toLowerCase() === property.toLowerCase(),
        );
        if (row.size !== 1) {
            return null;
        }

        const record = row.get(0).records.get(index);

        return record ? record.get('value') : null;
    };

    clearSearchContext() {
        const prefix = this.props.prefix;
        const module = sAction.dataGet(prefix + '/modul');
        const view = this.props.prefix.split('/').slice(-1)[0];
        const searchContext = sAction.getStorage('searchContext');

        if (searchContext && searchContext[`${module}_${view}`]) {
            searchContext[`${module}_${view}`] = {
                searchData: [],
            };
        }
        sAction.setStorage('searchContext', searchContext);
        this.forceUpdate();
    }


    getListView() {
        const filterValues = sAction.getFilterKeyValuePairs(this.props.data.filter);
        const data = this.props.data;
        const prefix = this.props.prefix;
        const orderBy = data.orderBy;
        const selectCallBack = this.props.parent.props.selectCallBack;
        const selectedSize = data.selected.size;
        const fieldWithActiveFiltering = {};
        data.filter.forEach((filter) => {
            fieldWithActiveFiltering[filter.field] = filter.filters;
        });
        const rows = [];
        let header = [];

        // for locked list view columns
        let lockedHeader = [];
        const lockedRows = [];
        let lockedColumnsCount = 0;

        if (this.table.current !== null) {
            const parent = this.table.current.closest('.subpanelContainer');
            if (parent != null) {
                if (parent.classList.contains('maxSize')) {
                    this.maxSizeSubpanel = true;
                } else {
                    this.maxSizeSubpanel = false;
                }
            }
        }

        if ((data.type != 'subpanel' &&
            data.type != 'reportWindow' &&
            data.selectedActive == true) ||
            (this.maxSizeSubpanel == true && data.selectedActive == true)
        ) {
            let disabledTickBox = false;
            const selectPage = data.selectPage;
            if (data.selected == 'all') {
                disabledTickBox = true;
            }
            lockedHeader = [
                <div
                    className="listViechCheckBoxTd listViwTableCell checkBoxRow"
                    key="select"
                >
                    <TickBox
                        disabled={disabledTickBox}
                        checked={selectPage}
                        onClick={(e) => {
                            sAction.toggleAll(!selectPage, prefix);
                            sAction.dataSet(prefix + '/selectPage', !selectPage);
                            if (this.props.data.get('modul') === 'Currencies') {
                                sAction.dataSet(`${prefix}/selected`, sAction.dataGet(`${prefix}/selected`).filter((val) => val !== '-99'));
                            }
                        }}
                    />
                </div>,
            ];

            if (!this.state.lockColumns) {
                header = lockedHeader;
            }
        }

        const checkboxColum = [];

        if ((data.type != 'subpanel' &&
            data.type != 'reportWindow' &&
            data.type != 'widget' &&
            data.selectedActive == true) ||
            (this.maxSizeSubpanel == true && data.selectedActive == true)
        ) {
            data.records.forEach((record, key) => {
                let selected = false;
                let disabledTickBox = false;
                let lineRecord = null;
                if (data.selected != 'all') {
                    lineRecord = data.selected.find((id) => id === record);
                    if (lineRecord != null) {
                        selected = true;
                    }
                } else {
                    selected = true;
                    disabledTickBox = true;
                }
                checkboxColum.push(
                    <div className="newListViewLine newListViewLineCheckBox" key={key}>
                        <TickBox
                            disabled={disabledTickBox}
                            key={selected}
                            onClick={(e) => {
                                if (record !== '-99' || this.props.data.get('modul') !== 'Currencies') {
                                    sAction.toggleLine(record, e.target.checked, prefix);
                                }
                            }}
                            checked={selected}
                        />
                    </div>,
                );
            });
        }
        data.rows.forEach((row, rowKey) => {
            const fieldName = row.def.get('name');
            const disabled = row.disabled;
            const fieldColors = data.colors.get(fieldName);
            const lines = [];
            row.records.forEach((line, lineKey) => {
                let module = line.get('module');
                if (!module) {
                    module = data.modul;
                }
                lines.push(
                    <NewListViewField
                        index={lineKey}
                        key={lineKey}
                        row={row}
                        rowIndex={rowKey}
                        line={line}
                        modul={module}
                        editModule={data.modul}
                        listType={data.type}
                        selectCallBack={selectCallBack}
                        uuid={data.records.get(lineKey)}
                        prefix={prefix}
                        getIdByIndex={this.getIdByIndex}
                        getPropertyValueByIndex={this.getPropertyValueByIndex}
                        target={this.props.target}
                        forceRightPanel={this.props.forceRightPanel}
                        bcColor={
                            fieldColors != undefined ?
                                fieldColors.get(line.get('value')) :
                                null
                        }
                        disabled={disabled}
                    />,
                );
            });

            let fieldOrder = false;
            if (row.key.toLowerCase() == orderBy) {
                fieldOrder = true;
            }

            let filtering = {
                state: false,
            };
            if (fieldWithActiveFiltering[row.key.toLowerCase()] != undefined) {
                fieldWithActiveFiltering[row.key.toLowerCase()].forEach((filter) => {
                    if (filter.footer == false) {
                        filtering = {
                            state: true,
                        };
                    }
                });
            }

            const headerFiled = (
                <NewListViewHeaderField
                    key={rowKey}
                    prefix={prefix}
                    data={row}
                    filterValues={filterValues}
                    asc={data.asc}
                    orderBy={fieldOrder}
                    filter={data.filter}
                    filtering={filtering}
                    openFilter={data.openFilter}
                    actFiltering={data.actFiltering}
                    last={data.rows.size == rowKey + 1}
                    sortable={row.sortable}
                    removeFieldText={data.removeFieldText}
                />);

            if (lockedColumnsCount < this.state.lockedColumns) {
                lockedHeader.push(headerFiled);
                lockedRows.push(
                    <div
                        key={rowKey}
                        data-width={row.width}
                        data-last={data.rows.size == rowKey + 1}
                        className="newListViewRow setWidth"
                    >
                        {lines}
                    </div>,
                );
                lockedColumnsCount++;
            } else {
                header.push(headerFiled);
                rows.push(
                    <div
                        key={rowKey}
                        data-width={row.width}
                        data-last={data.rows.size == rowKey + 1}
                        className="newListViewRow setWidth"
                    >
                        {lines}
                    </div>,
                );
            }
        });

        if (data.type == 'subpanel') {
            const lines = [];
            data.records.forEach((record, index) => {
                if (this.props.acl && this.props.acl.get('edit') == false) {
                    return;
                }
                lines.push(
                    <div
                        key={'subpanel_edit_' + index}
                        className="newListViewLine subpanelEditButton"
                    >
                        {!this.props.readonly &&
              <MoreOptions
                  className="right"
                  options={[
                      {
                          label: (<>
                              <div className='icon-removeRel buttonIcon'></div>
                              {sAction.translate('LBL_SUBPANEL_REMOVE_REL')}</>),
                          value: 'removeRel',
                          record: record,
                      },
                      {
                          label: (<>
                              <div className='icon-deleteIcon buttonIcon'></div>
                              {sAction.translate('LBL_SUBPANEL_DELETE_RECORD')}</>),
                          value: 'removeRecord',
                          record: record,
                      },
                  ]}
                  onClick={(e, val) => this.subpanelLineMoreAction(e, val, record)}
              >
                  <div className="subpanelLineMoreOptions icon-More"/>
              </MoreOptions>
                        }
                    </div>,
                );
            });
            rows.push(<div key="last">{lines}</div>);
            header.push(<div key="last" className="subpanelEditButton" />);
        }

        let filter = null;
        if (data.openFilterData != null && data.openFilterData.open == true) {
            let actFilter = null;
            let way = prefix;
            data.filter.forEach((f, k) => {
                if (f.field == data.openFilterData.field) {
                    actFilter = f;
                    way = way + '/filter/' + k;
                }
            });
            filter = (
                <ListViewFilterContainer
                    prefix={prefix}
                    way={way}
                    actFilter={actFilter}
                    index={data.filter.size}
                    open={data.openFilterData.open}
                    def={data.openFilterData.def}
                    fieldRel={data.openFilterData.fieldRel}
                    offset={data.openFilterData.offset}
                />
            );
        }

        let tree = null;
        if (data.listViewTree != null && data.listViewTree.tree !== null) {
            // if (data.type != "rightPanelQuotes") {
            tree = <ListViewTableTree data={data.listViewTree} way={prefix} />;
            // }
        }

        let tableLinesContainerClass = 'newListViewLines';
        if (data.actFiltering == true) {
            tableLinesContainerClass += ' activeFiltering';
        }

        let errorMessage = '';
        if (!data.rowCount) {
            errorMessage = (
                <div className="listviewMessage">
                    {sAction.translate('LBL_NO_MORE_RECORDS')}
                </div>
            );
        }

        return (
            <React.Fragment>
                {data.dropZoneActive == true && <ListViewTableDropZone way={prefix} />}
                {tree}
                <div className="newListView" ref={this.table}>
                    {filter}
                    <div className="newListViewContent">
                        {data.type != 'reportWindow' && (
                            <div className="filterContainer">
                                <div
                                    onClick={() => {
                                        this.clearSearchContext(); sAction.activateListViewFiltering(prefix);
                                    }}
                                    className="icon-filter listViewFilterIcon"
                                />
                            </div>
                        )}

                        <ScrollSync>
                            <div className='listViewWrapper'>


                                {/* first locked part of list view */}
                                { this.state.lockColumns ?
                                    <ScrollSyncPane>
                                        <div
                                            onScroll={(e) => this.scroll(e)}
                                            className="newListViewContentInner lockedColumns"
                                            id="newListViewContentInner"
                                        >
                                            <div ref={this.lockedHeader} className="newListViewHeader">
                                                {lockedHeader}
                                            </div>
                                            <div
                                                onMouseOver={(e) => this.mouseOver(e)}
                                                onMouseLeave={() => this.removeHover()}
                                                className={tableLinesContainerClass + ' lockedColumnsLines'}
                                            >
                                                {((data.type != 'subpanel' &&
                                                        data.type != 'reportWindow' &&
                                                        data.type != 'widget' &&
                                                        data.selectedActive == true) ||
                                                        (this.maxSizeSubpanel == true && data.selectedActive == true)) && (

                                                    <div className="newListViewRow checkBoxRow">
                                                        {checkboxColum}
                                                    </div>

                                                )}
                                                {lockedRows}
                                            </div>
                                        </div>
                                    </ScrollSyncPane> :
                                    null }


                                {/* scrollable rest of list view */}
                                <ScrollSyncPane>
                                    <div
                                        onScroll={(e) => this.scroll(e)}
                                        className="newListViewContentInner scrollableColumns"
                                        id={data.type != 'subpanel' ? 'newListViewContentInner' : ''}
                                    >
                                        <div ref={this.header} className="newListViewHeader">
                                            {header}
                                        </div>
                                        <div
                                            onMouseOver={(e) => this.mouseOver(e)}
                                            onMouseLeave={() => this.removeHover()}
                                            className={tableLinesContainerClass + ' scrollableColumnsLines'}
                                        >
                                            {((data.type != 'subpanel' &&
                                                data.type != 'reportWindow' &&
                                                data.type != 'widget' &&
                                                data.selectedActive == true) ||
                                                (this.maxSizeSubpanel == true && data.selectedActive == true)) &&
                                                !this.state.lockColumns && (
                                                <div className="newListViewRow checkBoxRow">
                                                    {checkboxColum}
                                                </div>
                                            )}
                                            {rows}
                                        </div>
                                        {errorMessage}
                                    </div>
                                </ScrollSyncPane>
                            </div>
                        </ScrollSync>

                    </div>
                    {data.type != 'subpanel' && (
                        <ListViewFooter
                            module={data.modul}
                            filter={data.filter}
                            offset={data.offset}
                            limit={data.limit}
                            rowCount={data.rowCount}
                            rowTotalCount={data.rowTotalCount}
                            selected={selectedSize}
                            selectedActive={data.selectedActive}
                            page={data.page}
                            prefix={prefix}
                            type={data.type}
                        />
                    )}
                    {data.selected.size != 0 && data.type == 'popup' && (
                        <div
                            onClick={() =>
                                selectCallBack({
                                    id:
                    (data.selected !== 'all') ?
                        data.selected.toJS() :
                        data.selected,
                                })
                            }
                            className="listViewPopupSelectButton"
                        >
                            {sAction.translate('LBL_SELECT') +
                ' (' +
                (data.selected.size ?
                    data.selected.size :
                    sAction.translate('LBL_ALL')) +
                ')'}
                        </div>
                    )}
                    {data.selected.size != 0 && data.type == 'subpanel' && this.maxSizeSubpanel && (
                        <div
                            onClick={() =>
                                sAction.deleteSubpanelRels({
                                    prefix: prefix,
                                    relid:
                    (data.selected !== 'all') ?
                        data.selected.toJS() :
                        data.selected,
                                })
                            }
                            className="listViewPopupSelectButton"
                        >
                            {sAction.translate('LBL_DELETE_REL') +
                ' (' +
                (data.selected.size ?
                    data.selected.size :
                    sAction.translate('LBL_ALL')) +
                ')'}
                        </div>
                    )}

                    {this.props.customFooter &&
                        <div className="customFooterListView">
                            {this.props.customFooter}
                        </div>
                    }
                </div>
            </React.Fragment>
        );
    }

    render() {
        const data = this.props.data;
        const way = this.props.prefix;
        let content = null;
        let customClass = '';
        if (data.category == 'list' || data.category == null) {
            content = this.getListView();
        } else if (data.category == 'customReport') {
            const reportId = data.customData.get('reportId');
            content = (
                <Report
                    data={data.customData}
                    way={way + '/customData'}
                    reportId={reportId}
                    paramData={{isDashboard: true, listview: true}}
                />
            );
            customClass = 'customReport';
        }

        return (
            <div
                className={'newListViewContainer ' + customClass}
                onDragOver={(e) => e.preventDefault()}
                onDragEnter={() => this.dragActive()}
            >
                {content}
            </div>
        );
    }
}

ListViewTable.propTypes = {
    acl: PropTypes.any,
    customFooter: PropTypes.any,
    data: PropTypes.shape({
        actFiltering: PropTypes.bool,
        asc: PropTypes.any,
        category: PropTypes.string,
        colors: PropTypes.any,
        customData: PropTypes.any,
        dropZoneActive: PropTypes.bool,
        filter: PropTypes.shape({
            forEach: PropTypes.func,
            size: PropTypes.any,
        }),
        get: PropTypes.func,
        limit: PropTypes.any,
        listViewTree: PropTypes.shape({
            tree: PropTypes.any,
        }),
        modul: PropTypes.string,
        offset: PropTypes.any,
        openFilter: PropTypes.any,
        openFilterData: PropTypes.shape({
            def: PropTypes.any,
            field: PropTypes.any,
            fieldRel: PropTypes.any,
            offset: PropTypes.any,
            open: PropTypes.bool,
        }),
        orderBy: PropTypes.any,
        page: PropTypes.any,
        records: PropTypes.any,
        removeFieldText: PropTypes.any,
        rowCount: PropTypes.any,
        rowTotalCount: PropTypes.any,
        rows: PropTypes.any,
        selectPage: PropTypes.any,
        selected: PropTypes.any,
        selectedActive: PropTypes.bool,
        type: PropTypes.string,
        lockedColumns: PropTypes.bool,
        lockedColumnsCount: PropTypes.number,
    }),
    forceRightPanel: PropTypes.any,
    parent: PropTypes.shape({
        props: PropTypes.shape({
            selectCallBack: PropTypes.func,
        }),
        subpanelLineMoreAction: PropTypes.func,
    }),
    prefix: PropTypes.string,
    readonly: PropTypes.any,
    target: PropTypes.any,
};
export default ListViewTable;
